import { ObjectsFactory, Model } from '../core'
import type { IPagination } from '../core'

export interface IRole {
  id: number
  name: string
  code: string
  description: string
  permission: IRolePermission[]
  created_at: Date
  updated_at: Date
}
export interface IRolePermission {
  id: number
  created_at: string
  updated_at: string
  resource: string
  description: string
  path: string
  method: string
  name: string
  is_default: boolean
  permission: IRolePermission
}

export interface IRolesListResponse extends IPagination {
  roleList: IRole[]
}

const modelConfig = {
  path: '/roles'
}

export enum RoleIdEnum {
  AGENT = 7,
  PLAYER = 8,
  SUPER_ADMIN = 1,
  HR = 2,
  FINANCE = 3,
  USER_EMPLOYER = 4
}

export class Role extends Model {
  [x: string]: any
  static queryKeys = {
    paginate: 'ROLES_PAGINATE_QUERY',
    findOne: 'ROLES_FIND_ONE_QUERY'
  }

  static objects = ObjectsFactory.factory<IRole>(modelConfig, this.queryKeys)

  static getRolesSelectOptions(roles: IRole[] | undefined) {
    if (!roles) return []

    return roles.map(item => ({
      value: item.id,
      label: item.name
    }))
  }
}

Role.setup(modelConfig)
